import React, { useState } from 'react';
import config from './config';
import { FaSync } from 'react-icons/fa';
import moment from 'moment';
import 'moment/locale/zh-tw';
import './EventUpload.css';

// Import the main component
import { ConstructionLogic, ResultsTable, WarningConditions } from '../components/EventUploadComponents';

// Set locale here for moment
moment.locale('zh-tw');

// Settings object containing all configuration
const settings = {
    project_command: "image_ai",
    priorityKeys: ['accident_event', 'anyone_not_wearing_helmets', 'dangerous_environment', 'people_smoking'],
    keyTranslations: {
        number_of_people: '人數',
        anyone_not_wearing_helmets: '有人未戴安全帽',
        clothing: '衣著',
        activity: '活動',
        helmets: '安全帽',
        position: '位置',
        location: '位置描述',
        ground: '地面',
        sky: '天空',
        lighting: '光線',
        equipment_quantity: '設備數量',
        equipment_type: '設備類型',
        dangerous_environment: '危險環境',
        people_smoking: '有人吸煙',
        description: '說明',
        name: "相機名稱",
        timestamp: "時間",
        image_url: '相片',
        thumbnail_url: '縮圖',
        accident_event: '事故事件',
        warning: '警告'
    },
    site_type: "工地",
    project_post_api: config.aiconstruction,
    media_upload_url: config.media2_upload,
    warningItems: [
        { key: 'accident_event', label: '事故事件' },
        { key: 'anyone_not_wearing_helmets', label: '有人未戴安全帽' },
        { key: 'dangerous_environment', label: '危險環境' },
        { key: 'people_smoking', label: '有人吸煙' }
    ],
    excludeKeys: ['id', 'time', 'thumbnail_url', 'image_url']
};

function Construction() {
    const [showResults, setShowResults] = useState(false);

    const handleResultsDisplay = (hasResults) => {
        setShowResults(hasResults);
    };

    const handleReload = () => {
        window.location.reload();
    };

    return (
        <>
            {showResults && (
                <div className="container d-flex justify-content-end mt-2">
                    <button
                        className="btn btn-secondary d-flex align-items-center gap-2"
                        onClick={handleReload}
                    >
                        <FaSync /> 重新偵測
                    </button>
                </div>
            )}
            {!showResults && (
                <div className="container text-center mt-0 mb-0">
                    <WarningConditions siteType={settings.site_type} warningItems={settings.warningItems} />
                </div>
            )}
            <ConstructionLogic
                keyTranslations={settings.keyTranslations}
                PROJECT_POST_API={settings.project_post_api}
                SITE_TYPE={settings.site_type}
                mediaUploadUrl={settings.media_upload_url}
                ResultsTableComponent={ResultsTable}
                configData={{
                    priorityKeys: settings.priorityKeys,
                    projectCommand: settings.project_command,
                    excludeKeys: settings.excludeKeys
                }}
                onResultsDisplay={handleResultsDisplay}
            />
        </>
    );
}

export default Construction;
